import { defineComponent as r, computed as o, openBlock as c, createElementBlock as h, createElementVNode as e, toDisplayString as v, createCommentVNode as n, normalizeStyle as d } from "vue";
const f = ["viewBox"], _ = /* @__PURE__ */ e("mask", { id: "c2e7bcf0-f4cf-4903-8a70-45b3ad91a169" }, [
  /* @__PURE__ */ e("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), m = { mask: "url(#c2e7bcf0-f4cf-4903-8a70-45b3ad91a169)" }, u = { key: 0 }, k = /* @__PURE__ */ e("path", {
  fill: "#eee",
  d: "M0 144.7 258.8 39.6 512 144.7v222.6L257 493 0 367.3z"
}, null, -1), p = /* @__PURE__ */ e("path", {
  fill: "#6da544",
  d: "M0 0v144.7h105.6v-22.2h33.6v22.2h33.3v-22.2h33.6v22.2h33.3v-22.2H273v22.2h33v-22.2h33.6v22.2h33.2v-22.2h33.6v22.2H512V0z"
}, null, -1), g = /* @__PURE__ */ e("path", {
  fill: "#d80027",
  d: "M0 367.3V512h512V367.3H406.4v22.4h-33.6v-22.4h-33.2v22.4H306v-22.4h-33v22.4h-33.6v-22.4h-33.3v22.4h-33.6v-22.4h-33.3v22.4h-33.6v-22.4zm339.1-178h-33.4c.2 3.7.4 7.4.4 11.1 0 24.8-6.2 48.8-17 66-3.3 5.2-9 12.6-16.4 17.6v-94.7h-33.4v94.8c-7.5-5-13-12.4-16.4-17.7-10.8-17-17-41-17-65.9 0-3.7.2-7.4.4-11H173a190 190 0 0 0-.4 11c0 68.7 36.7 122.5 83.5 122.5s83.5-53.8 83.5-122.5c0-3.7-.1-7.4-.4-11z"
}, null, -1), x = { fill: "none" }, w = ["r"], B = /* @__PURE__ */ r({
  __name: "ir",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(i) {
    const t = i, l = o(() => 512 + 2 * t.strokeWidth), s = o(() => -t.strokeWidth), a = o(() => 256 + t.strokeWidth / 2);
    return (y, z) => (c(), h("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${s.value} ${s.value} ${l.value} ${l.value}`
    }, [
      _,
      e("g", m, [
        t.flagName ? (c(), h("title", u, v(t.flagName), 1)) : n("", !0),
        k,
        p,
        g
      ]),
      e("g", x, [
        e("circle", {
          cx: "256",
          cy: "256",
          r: a.value,
          fill: "none",
          style: d({ stroke: t.strokeColor, strokeWidth: t.strokeWidth })
        }, null, 12, w)
      ])
    ], 8, f));
  }
});
export {
  B as default
};
//# sourceMappingURL=ir-c3a578db.js.map
